import { apiClient } from '@shared/api/client';

/**
 * Entity 목록 조회 (공통 엔드포인트)
 */
export const getEntities = async () => {
  const response = await apiClient.get('/startTask/common/entities');
  return response;
};

/**
 * Position 목록 조회 (공통 엔드포인트)
 * @param entityCd - Entity 코드
 */
export const getPositions = async (entityCd: string) => {
  const response = await apiClient.get(`/startTask/common/positions/${entityCd}`);
  return response;
};

/**
 * Officer Name 목록 조회 (공통 엔드포인트)
 */
export const getOfficers = async () => {
  const response = await apiClient.get('/startTask/common/officers');
  return response;
};

/**
 * Entity별 Officer 목록 조회
 * @param entityCd - Entity 코드
 * @param positionCd - Position 코드
 */
export const getOfficersByEntity = async (entityCd: string, positionCd: string) => {
  const response = await apiClient.get(`/startTask/common/officers-by-entity/${entityCd}`, {
    params: { positionCd }
  });
  return response;
};

/**
 * Entity별 Director 목록 조회 (Alternate Director 전용)
 * REGISTER_TYPE 조건 없이 POSITION_CD='B30027'로 필터링
 * @param entityCd - Entity 코드
 */
export const getDirectorsByEntityAlternate = async (entityCd: string) => {
  const response = await apiClient.get(`/startTask/common/directors-by-entity-alternate/${entityCd}`);
  return response;
};

/**
 * Entity별 다음 Certificate No 조회 (Allotment of Shares)
 */
export const getAllotmentNextCertificateNo = async (entityCd: string) => {
  const response = await apiClient.get(`/startTask/common/allotment-next-certificate-no/${entityCd}`);
  return response;
};

